import { STATUS_CODES } from 'network/config/error'
import { Error as ApplicationError } from 'network/config/error'
import {
  NotificationManager,
  NotificationTitleMessage,
} from '../NotificationsManager'

export const handleErrorNotification = (
  error: ApplicationError,
  title: NotificationTitleMessage = 'A problem occurred. Please try again.',
) => {
  if (error && error.code === STATUS_CODES.UNPROCESSABLE_ENTITY) {
    if (
      typeof error.validationErrors === 'string' &&
      error.validationErrors.length > 1
    ) {
      NotificationManager.error(error.validationErrors, error.message)
    } else {
      NotificationManager.error(error.message, title)
    }
  }
  if (error && error.code !== STATUS_CODES.UNPROCESSABLE_ENTITY) {
    NotificationManager.error(error.message, 'Oops, something happened!')
  }
}
